export default "__VITE_ASSET__D0Mqfh0e__"